import React, {useEffect, useState} from "react";
import initConfirm from "../../api/companyApproval/initConfirm";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../../components/modals/ErrorModal";
import {useNavigate} from "react-router-dom";
import shahkar from "../../api/companyApproval/shahkar";
import inquiryProcess from "../../api/companyApproval/inquiryProcess";
import PLATFORMS from "../../defaults/Platforms";
import createProcess from "../../api/companyApproval/createProcess";
import fetchProcess from "../../api/companyApproval/fetchProcess";
import createPayment from "../../api/companyApproval/createPayment";
import handleGenerateUuid from "../../api/global/generateUuid";
import resetProcess from "../../api/companyApproval/resetProcess";
import requestOtp from "../../api/companyApproval/requestOtp";
import {calculateOtpTimer, divarLinkGenerator, safeRedirect} from "../../helpers";
import verifyOtp from "../../api/companyApproval/VerifyOtp";
import companyBusinessInquiry from "../../api/companyApproval/companyBusinessInquiry";
import confirmCompany from "../../api/companyApproval/confirmCompany";
import deleteWidget from "../../api/companyApproval/deleteWidget";
import useDivarAuth from "../../../hooks/useDivarAuth";


export const CompanyApprovalContext = React.createContext({
    process: null,
    token: null,
    pid: null,
    postToken: null,
    components: null,
    isLoading: false,
    isReported: false,
    reportedMessage: '',
    reportedTitle: '',
    loadingMessage: '',
    widget: null,
    otpRequired: false,
    otpRequestLoading: false,
    otpConfirmLoading: false,
    otpError: null,
    otpTimer: 120,
    otpDescription: null,
    companyList: [],
    handleInitConfirm: () => {
    },
    handleCreateProcess: () => {
    },
    handleGetProcess: () => {
    },
    handleInquiryProcess: () => {
    },
    handleShahkar: () => {
    },
    handleLoading: () => {
    },
    handleError: () => {
    },
    handleRedirect: () => {},
    handleCreatePayment: () => {

    },
    handleRequestOTP: () => {
    },
    handleConfirmOTP: () => {
    },
    handleCompanyBusinessInquiry: () => {
    },
    handleConfirmCompany: () => {
    },
    handleDeleteWidget:()=>{}
});
const CompanyApprovalContextProvider = ({children}) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [loadingMessage, setLoadingMessage] = useState('لطفا منتظر بمانید')
    const [isReported, setIsReported] = useState(false);
    const [process, setProcess] = useState(null);
    const {serviceType,token,postToken,returnUrl}=useDivarAuth();

    const [components, setComponents] = useState(null);
    const [reportedMessage, setReportedMessage] = useState('');
    const [reportedTitle, setReportedTitle] = useState('')
    const [widget, setWidget] = useState(null)
    const [pid, setPid] = useState(null);
    const [otpRequired, setOtpRequired] = useState(false);
    const [otpRequestLoading, setRequestOtpLoading] = useState(false);
    const [otpConfirmLoading, setOtpConfirmLoading] = useState(false);
    const [otpError, setOtpError] = useState(false);
    const [otpTimer, setOtpTimer] = useState(120);
    const [otpDescription, setOtpDescription] = useState(null)
    const [companyList, setCompanyList] = useState([])
    useEffect(async () => {
        if (token) {
            await handleInquiryProcess();
        }
    }, []);
    const handleError = (status, message, data, callback) => {
        if (status === -9) {
            //rate limit error
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'بازگشت به دیوار',
                confirmButtonTheme: "red",
                onConfirm: () => {
                    handleRedirect()
                }
            })
        } else if (status === -20) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: false,
                showConfirmButton: false,
            })
        } else if (status === -10) {
            setIsLoading(false)
            setIsReported(true)
            setReportedMessage(message)
        } else if (status === 500) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای سرویس',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'بستن',
                cancelButtonTheme: 'red',

                onCancel: () => {


                }
            })

        } else if (status === 403 || status===401) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'دریافت دسترسی ',
                cancelButtonTheme: 'red',

                onCancel: () => {
                    navigate(`/auth/gate/v11dW62X4kaZ2Hn4/${serviceType}?post_token=${postToken}${returnUrl ? '&return_url=' + returnUrl : ''}`)
                }
            })
        } else if (status === 801 || status === 802 || status === 803 || status === 805 || status === -100) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'ساخت پروسه جدید',
                cancelButtonTheme: 'red',
                onCancel: async () => {
                    await handleCreateProcess();
                }
            })
        } else {
            callback()
        }

    }
    const handleInquiryProcess = async () => {
        setLoadingMessage('لطفا منتظر بمانید');
        setIsLoading(true);
        try {
            const params = {
                service_type: serviceType,
                post_token: postToken,
            }
            const response = await inquiryProcess(token, params);

            const {hasError, message, data, status} = response;
            if (hasError) {
                handleError(status, message, data, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message || 'خطای سرویس',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: 'تلاش مجدد',
                        cancelButtonTheme: 'red',
                        onCancel: async () => {
                            await handleInquiryProcess();
                        }
                    })
                })
            } else {
                if (data?.process && data?.process?.pid) {
                    if (data?.widget && data?.widget?.has_widget) {
                        setIsLoading(false)
                        setWidget(data?.widget);
                    } else {
                        if (data?.components?.current_component.name !== "Final") {
                            setPid(data.process.pid);
                            await handleGetProcess(data.process.pid)
                        } else {
                            await handleCreateProcess();
                        }

                    }
                } else {
                    await handleCreateProcess();
                }
            }
        } catch {

        }
    }
    const handleCreateProcess = async () => {
        setIsLoading(true);
        setLoadingMessage('در حال ساخت فرایند')
        try {
            const params = {
                post_token: postToken
            }
            const response = await createProcess(token, params);
            const {status, message, data, hasError} = response;
            if (hasError) {
                handleError(status, message, data, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message || '',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: 'تلاش مجدد',
                        cancelButtonTheme: 'red',
                        onCancel: async () => {
                            await handleCreateProcess();
                        }
                    })
                })
            } else {
                setIsLoading(true)
                setPid(data.pid);
                await handleGetProcess(data.pid)
            }
        } catch {

        }
    }
    const handleLoading = (loading) => {
        setIsLoading(loading)
    }
    const handleGetProcess = async (pid) => {
        setLoadingMessage('در حال دریافت اطلاعات');
        setIsLoading(true)
        try {
            const params = {
                pid: pid,
            }
            const response = await fetchProcess(token, params);
            const {status, message, data, hasError} = response;
            if (hasError) {
                handleError(status, message, data, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message || '',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: 'تلاش مجدد',
                        cancelButtonTheme: 'red',
                        onCancel: async () => {
                            await handleGetProcess(pid);
                        }
                    })
                })
            } else {
                setComponents(data.components)
                setProcess(data.process);

                if (data.components.current_component.name === PLATFORMS.DIVAR.APPS.COMPANY_APPROVAL.STEPS.SHAHKAR) {
                    await handleShahkar(data.process.pid);
                } else if (data.components.current_component.name === PLATFORMS.DIVAR.APPS.COMPANY_APPROVAL.STEPS.COMPANY_BUSINESS_LICENSE_INQUIRY) {
                    await handleCompanyBusinessInquiry(data.process.pid)
                } else {
                    setIsLoading(false);
                }

            }
        } catch {

        }
    }
    const handleCreatePayment = async () => {
        setIsLoading(true);

        const params = {
            "pid": pid,
        }
        const response = await createPayment(token, params);
        const {hasError, message, status, data} = response;
        if (hasError) {
            setIsLoading(true)
            handleError(data, message, status, () => {
                Reoverlay.showModal(ErrorModal, {
                    title: 'خطا',
                    message: message,
                    showCancelButton: true,
                    cancelButtonText: 'تلاش مجدد',
                    onCancel: async () => {
                        await handleCreatePayment()
                    }
                })
            })
        } else {
            if (data.pay_url) {
                setIsLoading(true);
                setLoadingMessage('در حال انتقال به درگاه بانکی')
                safeRedirect(data.pay_url,()=>{
                    setIsLoading(false);
                    Reoverlay.showModal(ErrorModal,{
                        title:'خطا',
                        message:'لینک معتبر نمی باشد.',
                        showCancelButton: true,
                        cancelButtonText:'بستن',
                        onCancel:()=>{
                            Reoverlay.hideModal();
                            navigate('/404')

                        }
                    })
                })
            }
        }
    };
    const handleReset = async (pid) => {
        setLoadingMessage('لطفا منتظر بمانید');
        setIsLoading(true);
        const params = {pid}

        try {
            const response = await resetProcess(token, params);
            const {status, message, data, hasError} = response;
            if (hasError) {
                handleError(status, message, data, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message,

                        showCancelButton: true,
                        cancelButtonText: 'تلاش مجدد',
                        cancelButtonTheme: 'red',
                        onConfirm: () => {
                            Reoverlay.hideModal();
                        },
                        onCancel: async () => {
                            Reoverlay.hideModal();
                            await handleReset(pid)
                        }
                    })
                })
            } else {
                await handleGetProcess(pid);
            }
        } catch {

        }
    }
    const handleShahkar = async (pid) => {
        setIsLoading(true);
        setLoadingMessage('در حال تطبیق شماره موبایل و کد ملی')
        handleGenerateUuid('Shahkar', token).then(async uuid => {
            const params = {
                pid,
                uuid: uuid
            }
            try {
                const response = await shahkar(token, params);
                const {message, data, status, hasError} = response;
                if (hasError) {
                    setIsLoading(false);
                    handleError(status, message, data, () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message,
                            showConfirmButton: data?.can_reset,
                            confirmButtonText: 'ویرایش اطلاعات',
                            confirmButtonTheme: "light",
                            showCancelButton: !data?.can_reset,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: async () => {
                                Reoverlay.hideModal();
                                if (data.can_reset) {
                                    await handleReset(pid);
                                }

                            },
                            onCancel: async () => {
                                Reoverlay.hideModal();
                                await handleShahkar(pid);
                            }
                        })
                    })
                } else {
                    await handleGetProcess(pid)
                }
            } catch {

            }

        }).catch(error => {
            console.log(error);
            setIsLoading(false);
            setLoadingMessage('لطفا منتظر بمانید')
        });

    }
    const handleRequestOTP = async () => {
        setRequestOtpLoading(true);
        setOtpError('');
        setOtpDescription('');
        try {
            const params = {
                pid,
            }
            const response = await requestOtp(token, params);
            const {data, status, message, hasError} = response;
            setIsLoading(false);
            setRequestOtpLoading(false)
            if (hasError) {
                handleError(status, message, data, () => {
                    setOtpError(response.message);
                })
            } else {
                const time = calculateOtpTimer(data.created_at, 120);

                setOtpTimer(time);
                setOtpRequired(true)
                setOtpDescription(message)
            }
        } catch {

        }
    }
    const handleConfirmOTP = async (code) => {
        setOtpConfirmLoading(true);
        setOtpError('')
        const params = {
            code, pid
        }
        try {
            const response = await verifyOtp(token, params);
            const {status, message, data, hasError} = response;
            setOtpConfirmLoading(false);
            if (hasError) {
                handleError(status, message, data, () => {
                    setOtpError(message);
                })
            } else {
                setOtpRequired(false);
                setOtpError(null);
                setOtpDescription(null);

                await handleGetProcess(pid)
            }
        } catch {

        }
    }
    const handleInitConfirm = async (params) => {
        setIsLoading(true);
        setLoadingMessage('در حال ارسال اطلاعات')
        try {
            const response = await initConfirm(token, params);

            const {message, hasError, data, status} = response;
            if (hasError) {
                setIsLoading(false);
                handleError(status, message, data, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message || '',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: 'بستن',
                        cancelButtonTheme: 'red',

                        onCancel: () => {
                            Reoverlay.hideModal();
                        }
                    })
                })
            } else {
                if (data.otp_required) {
                    setOtpRequired(true);
                    await handleRequestOTP()
                } else {
                    setIsLoading(true);
                    await handleGetProcess(pid);
                }

            }
        } catch (e) {
            setIsLoading(false);

        }
    }
    const handleCompanyBusinessInquiry = async (pid) => {
        setLoadingMessage('در حال استعلام مجوز ');
        setIsLoading(true);
        handleGenerateUuid('CompanyBusinessLicenseInquiry', token).then(async uuid => {
            try {
                const response = await companyBusinessInquiry(token, {pid, uuid});
                const {status, data, message, hasError} = response;
                if (hasError) {
                        handleError(status,message,data,()=>{
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message,
                                showConfirmButton: data?.can_reset,
                                confirmButtonText: 'ویرایش اطلاعات',
                                confirmButtonTheme: "light",
                                showCancelButton: !data?.can_reset,
                                cancelButtonText: 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                onConfirm: async () => {
                                    Reoverlay.hideModal();
                                    if (data.can_reset) {
                                        await handleReset(pid);
                                    }

                                },
                                onCancel: async () => {
                                    Reoverlay.hideModal();
                                    await handleCompanyBusinessInquiry(pid);
                                }
                            })
                        })
                } else {
                    if (data) {

                        setCompanyList(data.data);
                        setIsLoading(false)
                    }
                }
            } catch {

            }
        })

    }
    const handleConfirmCompany = async (businessIndex) => {
        setLoadingMessage('لطفا منتظر بمانید');
        setIsLoading(true)
        try {
            const response = await confirmCompany(token, {
                pid,
                bi_index:businessIndex
            });
            const {data, status, message, hasError} = response;
            if (hasError) {
                handleError(status,message,data,()=>{
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message,

                        showCancelButton: true,
                        cancelButtonText: 'تلاش مجدد',
                        cancelButtonTheme: 'red',
                        onConfirm: () => {
                            Reoverlay.hideModal();
                        },
                        onCancel: async () => {
                            Reoverlay.hideModal();
                            await handleConfirmCompany()
                        }
                    })
                })
            } else {
                if(data.warning){
                    setIsReported(true);
                    setReportedMessage(data.warning);
                    setIsLoading(false)
                }else {
                    await handleGetProcess(pid)
                }
            }
        } catch {

        }
    }
    const handleDeleteWidget=async ()=>{
        setIsLoading(true)
        setLoadingMessage('در حال حذف افزونه')
        try {
            const response=await deleteWidget(token,{pid:widget.pid});
            const {hasError,message,status,data}=response;
            if(hasError){
                setIsLoading(false)
                handleError(status,message,data,()=>{
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message || 'خطای سرویس',
                        onConfirm: () => {
                            Reoverlay.hideModal();
                        },
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: 'بستن',
                        cancelButtonTheme: 'red',

                        onCancel: () => {


                        }
                    })
                })
            }else {
                setWidget(null)
                await handleInquiryProcess();
            }
        }catch {

        }
    }
    const handleRedirect = () => {
        const link = divarLinkGenerator({
            returnUrl,
            price:0,
            status:'success',

        });
        safeRedirect(link,()=>{
            Reoverlay.showModal(ErrorModal,{
                title:'خطا',
                message:'لینک معتبر نمی باشد.',
                showCancelButton: true,
                cancelButtonText:'بستن',
                onCancel:()=>{
                    Reoverlay.hideModal();
                    navigate('/404')

                }
            })
        })
    }
    return <CompanyApprovalContext.Provider value={{
        widget,
        components,
        pid,
        isLoading,
        isReported,
        postToken,
        process,
        reportedMessage,
        reportedTitle,
        token,
        loadingMessage,
        otpTimer,
        otpError,
        otpDescription,
        otpRequired,
        otpRequestLoading,
        otpConfirmLoading,
        companyList,
        handleError,
        handleCreateProcess,
        handleGetProcess,
        handleInitConfirm,
        handleLoading,
        handleInquiryProcess,
        handleRedirect,
        handleShahkar,
        handleCreatePayment,
        handleRequestOTP,
        handleConfirmOTP,
        handleCompanyBusinessInquiry,
        handleConfirmCompany,
        handleDeleteWidget


    }}>
        {children}
    </CompanyApprovalContext.Provider>;
}
export default CompanyApprovalContextProvider;